"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "DataSwitchContext", {
  enumerable: true,
  get: function get() {
    return _context["default"];
  }
});
Object.defineProperty(exports, "withDataSwitchContext", {
  enumerable: true,
  get: function get() {
    return _withDataSwitchContext["default"];
  }
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _common = require("../../common");

var _constants = require("../../constants");

var _lib = require("../../lib");

var _context = _interopRequireDefault(require("./context"));

var _withDataSwitchContext = _interopRequireDefault(require("./withDataSwitchContext"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var DataSwitch =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(DataSwitch, _PureComponent);

  function DataSwitch(props) {
    var _this;

    _classCallCheck(this, DataSwitch); // prioritise value over index


    _this = _possibleConstructorReturn(this, _getPrototypeOf(DataSwitch).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getSelectedIndex", function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.value;
      var _this$props = _this.props,
          data = _this$props.data,
          keySelector = _this$props.keySelector,
          selectedCondition = _this$props.selectedCondition;

      if ((0, _lib.arrayHasItems)(data)) {
        return data.findIndex(function (d, idx, arr) {
          return selectedCondition({
            data: d,
            keySelector: keySelector,
            value: value
          }, idx, arr);
        });
      }

      return -1;
    });

    _defineProperty(_assertThisInitialized(_this), "getSelectedData", function () {
      var data = _this.props.data;

      if ((0, _lib.arrayHasItems)(data)) {
        var index = _this.getSelectedIndex();

        if (index > -1) {
          return data[index];
        }
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "getCallBackData", function () {
      var data = _this.props.data;
      var value = _this.state.value;
      return {
        data: data,
        value: value,
        selected: _this.getSelectedData(),
        selectedIndex: _this.getSelectedIndex()
      };
    });

    _defineProperty(_assertThisInitialized(_this), "getDataLength", function () {
      var data = _this.props.data;

      if ((0, _lib.arrayHasItems)(data)) {
        return data.length;
      }

      return 0;
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnNext", function (e) {
      var _this$props2 = _this.props,
          onNext = _this$props2.onNext,
          onChange = _this$props2.onChange,
          loopable = _this$props2.loopable;

      var currentIndex = _this.getSelectedIndex();

      var nextIndex = currentIndex;

      var dataLength = _this.getDataLength();

      if (dataLength) {
        var lastIndex = dataLength - 1;

        if (currentIndex <= lastIndex) {
          nextIndex = currentIndex + 1;
        }

        if (nextIndex > lastIndex) {
          nextIndex = lastIndex;

          if (loopable) {
            if ((0, _lib.isBool)(loopable) || (0, _lib.isString)(loopable) && loopable === 'last') {
              nextIndex = 0;
            }
          }
        }

        if (nextIndex !== currentIndex) {
          var newValue = DataSwitch.getSelectedValue(_this.props, nextIndex);

          _this.setState({
            value: newValue
          }, function () {
            var data = _this.getCallBackData();

            onNext(e, data);
            onChange(e, data);
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnPrev", function (e) {
      var _this$props3 = _this.props,
          onPrev = _this$props3.onPrev,
          onChange = _this$props3.onChange,
          loopable = _this$props3.loopable;

      var currentIndex = _this.getSelectedIndex();

      var nextIndex = currentIndex;

      var dataLength = _this.getDataLength();

      if (dataLength) {
        var lastIndex = dataLength - 1;

        if (currentIndex <= dataLength) {
          nextIndex = currentIndex - 1;
        }

        if (nextIndex < 0) {
          nextIndex = 0;

          if (loopable) {
            if ((0, _lib.isBool)(loopable) || (0, _lib.isString)(loopable) && loopable === 'first') {
              nextIndex = lastIndex;
            }
          }
        }

        if (nextIndex !== currentIndex) {
          var newValue = DataSwitch.getSelectedValue(_this.props, nextIndex);

          _this.setState({
            value: newValue
          }, function () {
            var data = _this.getCallBackData();

            onPrev(e, data);
            onChange(e, data);
          });
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (e, _ref) {
      var value = _ref.value;

      _this.setState({
        value: value
      }, function () {
        var onChange = _this.props.onChange;

        var data = _this.getCallBackData();

        onChange(e, data);
      });
    });

    var _value = props.value,
        selectedIndex = props.selectedIndex;
    var _newValue = props.value;

    if (!_newValue && (0, _lib.isNumber)(selectedIndex) && selectedIndex > -1) {
      _newValue = DataSwitch.getSelectedValue(props, selectedIndex);
    }

    _this.state = {
      prevProps: {
        value: _value,
        selectedIndex: selectedIndex
      },
      value: _newValue
    };
    return _this;
  }

  _createClass(DataSwitch, [{
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          data = _this$props4.data;
      var value = this.state.value;
      var context = {
        data: data,
        value: value,
        selected: this.getSelectedData(),
        selectedIndex: this.getSelectedIndex(),
        onChange: this.handleOnChange,
        onNext: this.handleOnNext,
        onPrev: this.handleOnPrev
      };
      return _react["default"].createElement(_context["default"].Provider, {
        value: context
      }, (0, _lib.getRenderProps)(children, context));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // prioritise value over index
      var prevProps = state.prevProps; // Compare the incoming prop to previous prop

      var value = props.value,
          selectedIndex = props.selectedIndex;
      var newValue = state.value; // get value based on selected index

      if (prevProps.selectedIndex !== selectedIndex && (0, _lib.isNumber)(selectedIndex) && selectedIndex > -1) {
        newValue = DataSwitch.getSelectedValue(props, selectedIndex);
      } // get new value


      if (prevProps.value !== value) {
        newValue = value;
      }

      return {
        // Store the previous props in state
        prevProps: {
          value: value,
          selectedIndex: selectedIndex
        },
        value: newValue
      };
    }
  }]);

  return DataSwitch;
}(_react.PureComponent);

exports["default"] = DataSwitch;

_defineProperty(DataSwitch, "Consumer", _context["default"].Consumer);

_defineProperty(DataSwitch, "propTypes", {
  children: _common.customPropTypes.render,
  data: _propTypes["default"].instanceOf(Array),
  value: _common.customPropTypes.stringOrNumber,
  selectedIndex: _propTypes["default"].number,
  onChange: _propTypes["default"].func,
  onNext: _propTypes["default"].func,
  onPrev: _propTypes["default"].func,
  selectedCondition: _propTypes["default"].func,
  loopable: _propTypes["default"].oneOfType([_propTypes["default"].oneOf(_constants.ORDER_TYPES), _propTypes["default"].bool]),
  keySelector: _common.customPropTypes.as
});

_defineProperty(DataSwitch, "defaultProps", {
  children: null,
  data: [],
  value: undefined,
  selectedIndex: 0,
  onChange: function onChange() {},
  onNext: function onNext() {},
  onPrev: function onPrev() {},
  loopable: false,
  selectedCondition: function selectedCondition(_ref2) {
    var data = _ref2.data,
        keySelector = _ref2.keySelector,
        value = _ref2.value;
    return value ? (0, _lib.getSelectorValue)(data, keySelector) === value : false;
  },
  keySelector: function keySelector(d) {
    return d ? d.value : null;
  }
});

_defineProperty(DataSwitch, "getSelectedValue", function (props, index) {
  var data = props.data,
      keySelector = props.keySelector;

  if ((0, _lib.isNumber)(index) && index > -1) {
    return (0, _lib.getSelectorValue)(data[index], keySelector);
  }

  return null;
});